export const MARRIAGES_ON_DELETE_REQUESTED = 'MARRIAGES_ON_DELETE_REQUESTED';
export const MARRIAGES_ON_DELETE_SUCCEEDED = 'MARRIAGES_ON_DELETE_SUCCEEDED';
export const MARRIAGES_ON_DELETE_FAILED = 'MARRIAGES_ON_DELETE_FAILED';

export const MARRIAGES_ON_DELETE_FILE_REQUESTED = 'MARRIAGES_ON_DELETE_FILE_REQUESTED';
export const MARRIAGES_ON_DELETE_FILE_SUCCEEDED = 'MARRIAGES_ON_DELETE_FILE_SUCCEEDED';
export const MARRIAGES_ON_DELETE_FILE_FAILED = 'MARRIAGES_ON_DELETE_FILE_FAILED';

export const MARRIAGES_ON_GET_ALL_REQUESTED = 'MARRIAGES_ON_GET_ALL_REQUESTED';
export const MARRIAGES_ON_GET_ALL_SUCCEEDED = 'MARRIAGES_ON_GET_ALL_SUCCEEDED';
export const MARRIAGES_ON_GET_ALL_FAILED = 'MARRIAGES_ON_GET_ALL_FAILED';

export const MARRIAGES_ON_GET_FORM_REQUESTED = 'MARRIAGES_ON_GET_FORM_REQUESTED';
export const MARRIAGES_ON_GET_FORM_SUCCEEDED = 'MARRIAGES_ON_GET_FORM_SUCCEEDED';
export const MARRIAGES_ON_GET_FORM_FAILED = 'MARRIAGES_ON_GET_FORM_FAILED';

export const MARRIAGES_ON_GET_ONE_REQUESTED = 'MARRIAGES_ON_GET_ONE_REQUESTED';
export const MARRIAGES_ON_GET_ONE_SUCCEEDED = 'MARRIAGES_ON_GET_ONE_SUCCEEDED';
export const MARRIAGES_ON_GET_ONE_FAILED = 'MARRIAGES_ON_GET_ONE_FAILED';

export const MARRIAGES_ON_SAVE_REQUESTED = 'MARRIAGES_ON_SAVE_REQUESTED';
export const MARRIAGES_ON_SAVE_SUCCEEDED = 'MARRIAGES_ON_SAVE_SUCCEEDED';
export const MARRIAGES_ON_SAVE_FAILED = 'MARRIAGES_ON_SAVE_FAILED';
